import { getHttpClient } from '../axiosInstance'

const base = '/admin/settings/v1'

export const load = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/theme`

  const response = await apiClient.get(url)
  return response.data
}

export const update = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/theme`

  const response = await apiClient.post(url, form)
  return response.data
}
